// extracted by mini-css-extract-plugin
export default {"root":"---------packages-corgi-x-src-components-Grid-Grid-module__root"};